import type { Catalog } from '@smarton-pbx/shared';

/** Texts (SMS): the Texts page, and texts on the numbers, carriers and settings pages. */
export const texts: Catalog = {
  Texts: 'SMS',
  'Texts (SMS) to and from your numbers.': 'SMS žinutės, gautos jūsų numeriais ir išsiųstos iš jų.',
  'New text': 'Nauja SMS',
  'No texts yet': 'SMS žinučių dar nėra',
  'When someone texts one of your numbers, it appears here.': 'Kai kas nors atsiųs SMS jūsų numeriu, ji atsiras čia.',
  'Choose a conversation': 'Pasirinkite pokalbį',
  'Or start a new one with New text.': 'Arba pradėkite naują mygtuku „Nauja SMS“.',
  'All texts': 'Visos SMS',
  'via {number}': 'per {number}',
  'You:': 'Jūs:',
  'Write a text…': 'Rašykite SMS…',
  Text: 'SMS',
  'Text {name}': 'Siųsti SMS: {name}',
  Send: 'Siųsti',
  'Sending…': 'Siunčiama…',
  'Not sent': 'Neišsiųsta',
  '{n} SMS': '{n} SMS',
  '{n} characters left': { one: 'liko {n} simbolis', few: 'liko {n} simboliai', other: 'liko {n} simbolių' },
  '{n} unread': { one: '{n} neperskaitytas', few: '{n} neperskaityti', other: '{n} neperskaitytų' },
  'Too long for one text: shorten it': 'Per ilga vienai SMS: sutrumpinkite',
  'They texted from a name, not a number, so you can’t reply.': 'Žinutė atsiųsta su vardu, o ne numeriu, todėl į ją atsakyti negalima.',
  'Texts are off for {number}. An admin can turn them on in Settings, Numbers.':
    'Numeriui {number} SMS išjungtos. Administratorius gali jas įjungti skiltyje „Nustatymai“, „Numeriai“.',
  'No number to text from': 'Nėra numerio, iš kurio siųsti SMS',
  'Texts go from one of the company’s numbers with texts turned on. Ask an admin to turn them on for your number.':
    'SMS siunčiamos iš įmonės numerio, kuriam įjungtos SMS. Paprašykite administratoriaus jas įjungti jūsų numeriui.',
  'text|To': 'Kam',
  'text|From': 'Iš',
  'Their number, as you would dial it': 'Gavėjo numeris, kaip jį rinktumėte',
  'From {number}': 'Iš {number}',

  // Settings: carriers, numbers, limits, notifications.
  'Texts (SMS)': 'SMS žinutės',
  'Only if the carrier passes texts over SIP (MESSAGE). Then turn them on for each number.':
    'Tik jei ryšio operatorius perduoda SMS per SIP (MESSAGE). Tada įjunkite jas kiekvienam numeriui.',
  'Not passed': 'Neperduoda',
  'Passed over SIP': 'Perduoda per SIP',
  'Texts: {name}': 'SMS: {name}',
  'Texts (SMS) to the number, and replies from it': 'SMS žinutės šiuo numeriu ir atsakymai iš jo',
  'Its carrier doesn’t pass texts. Turn them on for the carrier first.': 'Šio numerio ryšio operatorius SMS neperduoda. Pirmiausia įjunkite jas operatoriui.',
  'Where its calls go': 'Ten, kur ir jo skambučiai',
  'To the admins and the region’s managers': 'Administratoriams ir regiono vadovams',
  'To a queue': 'Į eilę',
  'Texts per day, per person': 'SMS per dieną vienam žmogui',
  'Then their texts stop until tomorrow': 'Tada iki rytojaus jie SMS siųsti negali',
  'A text (SMS) to your number, or one whose texts come to you': 'SMS jūsų numeriu arba numeriu, kurio SMS gaunate jūs',
};
